import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { DavidC_Video3 } from '../../../../../utils/ES/Modals/aiArtists';

const ModalVideoDavidC3 = () => {
  return (
    <>
      <ModalVideo
        id="david-video-3"
        dataText={DavidC_Video3}
        videoSrc="https://www.youtube.com/embed/zcCrTUxFbFk?si=OfX2HGnve8vpvHPe"
        videoTitle="KUTER_STUDIO_AI_DAVID_C_VIDEO_3"
      />
    </>
  );
};

export default ModalVideoDavidC3;
